import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react'

type MeasureDetailHeaderSlotContextValue = {
  headerRight: ReactNode
  setHeaderRight: (node: ReactNode) => void
}

const MeasureDetailHeaderSlotContext = createContext<MeasureDetailHeaderSlotContextValue | null>(null)

export const MeasureDetailHeaderSlotProvider = ({ children }: { children: ReactNode }) => {
  const [headerRight, setHeaderRightState] = useState<ReactNode>(null)

  const setHeaderRight = useCallback((node: ReactNode) => {
    setHeaderRightState(node)
  }, [])

  const value = useMemo(() => ({ headerRight, setHeaderRight }), [headerRight, setHeaderRight])

  return <MeasureDetailHeaderSlotContext.Provider value={value}>{children}</MeasureDetailHeaderSlotContext.Provider>
}

export const useMeasureDetailHeaderSlot = () => useContext(MeasureDetailHeaderSlotContext)
